import React, { useEffect, useState, useRef } from 'react';
import NitroButton from '../parts/NitroButton';
import Matter from 'matter-js';

import wand from '../../sounds/wand.mp3';

const BucketSorter = ({ qData, pageStyle, theme, nextStep }) => {

  let shapeBgColor = theme.pageStyle2.hint1,
    shapeFontColor = theme.pageStyle2.textColor,
  wallColor = "transparent",
  bColor = "pink" // buckets are off screen
  if (pageStyle==1) {
    shapeBgColor = theme.pageStyle1.hint1;
    shapeFontColor = '#FFFFFF';
  }

  const boxRef = useRef(null)

  const [constraints, setContraints] = useState()
  const [scene, setScene] = useState()
  const [collectResponses, setCollectResponses] = useState([])
  const [allComplete, setAllComplete] = useState(false)

  const handleResize = () => {
    setContraints(boxRef.current.getBoundingClientRect())
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  const words = qData.categories;
  const buckets = qData.options;
  const numberOfBuckets = buckets.length;
  let fontSize = 22,
    shapeSize = 150,
    w = window.innerWidth,
    h = window.innerHeight;

  if (w < 600) {
    fontSize = 16
    shapeSize = 90
  }

  // buckets are 300px thick and shapes can be 300px in diameter
  var distanceOffset = (300 / 2) + (shapeSize/1.9);

  useEffect(() => {

    let wordIndex = 0;
    let userClicking = false;

    //Random Number generator
    const random = (min, max) => {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    const randomShape = () => {
      let possibleSides = [1,4,5,6,8]
      return possibleSides[random(0, 4)]
    }

    var Engine = Matter.Engine,
      Render = Matter.Render,
      World = Matter.World,
      Bodies = Matter.Bodies,
      Body = Matter.Body,
      Events = Matter.Events,
      MouseConstraint = Matter.MouseConstraint,
      Mouse = Matter.Mouse;

    var engine = Engine.create();

    var render = Render.create({
      element: boxRef.current,
      engine: engine,
      options: {
        width: w,
        height: h,
        wireframes: false,
        background: 'transparent'
      }
    });

    engine.gravity.y = 0;

    // add mouse control
    var mouse = Mouse.create(render.canvas),
      mouseConstraint = MouseConstraint.create(engine, {
        mouse: mouse,
        constraint: {
          stiffness: 1,
          render: { visible: false }
        }
      });

    // Corners
    var corner_top_left_x = Bodies.rectangle(w / 20, -280, w / 10, 600, { label: 'corner_top_left_x', isStatic: true, render: { fillStyle: wallColor } })
    var corner_top_left_y = Bodies.rectangle(-280, h / 20, 600, h / 10, { label: 'corner_top_left_y', isStatic: true, render: { fillStyle: wallColor } })
    var corner_top_right_x = Bodies.rectangle(w - (w / 20), -280, (w / 10), 600, { label: 'corner_top_right_x', isStatic: true, render: { fillStyle: wallColor } })
    var corner_top_right_y = Bodies.rectangle(w + 280, h / 20, 600, h / 10, { label: 'corner_top_right_y', isStatic: true, render: { fillStyle: wallColor } })
    var corner_bottom_left_x = Bodies.rectangle(w / 20, h + 280, w / 10, 600, { label: 'corner_bottom_left_x', isStatic: true, render: { fillStyle: wallColor } } )
    var corner_bottom_left_y = Bodies.rectangle(-280, h - (h / 20), 600, h / 10, { label: 'corner_bottom_left_y', isStatic: true, render: { fillStyle: wallColor } })
    var corner_bottom_right_x = Bodies.rectangle(w - (w / 20), h + 280, (w / 10), 600, { label: 'corner_bottom_right_x', isStatic: true, render: { fillStyle: wallColor } })
    var corner_bottom_right_y = Bodies.rectangle(w + 280, h - (h / 20), 600, h / 10, { label: 'corner_bottom_right_y', isStatic: true, render: { fillStyle: wallColor } })

    //Walls
    var topWall = Bodies.rectangle(w / 2, -280, w - (w / 5), 600, { label: 'topWall', isStatic: true, render: { fillStyle: wallColor } })
    var bottomWall = Bodies.rectangle(w / 2, h + 280, w - (w / 5), 600, { label: 'bottomWall', isStatic: true, render: { fillStyle: wallColor } });
    var leftWall = Bodies.rectangle(-280, h / 2, 600, h - (h / 5), { label: 'leftWall', isStatic: true, render: { fillStyle: wallColor } });

    var bucketTop = Bodies.rectangle(w / 2, -distanceOffset, w, 300, { label: 'bucketTop', isSensor: true, isStatic: true, render: { fillStyle: bColor } });
    var bucketBottom = Bodies.rectangle(w / 2, h + distanceOffset, w, 300, { label: 'bucketBottom', isSensor: true, isStatic: true, render: { fillStyle: bColor } });
    var bucketLeft = Bodies.rectangle(-distanceOffset, h / 2, 300, h - (h / 5), { label: 'bucketLeft', isSensor: true, isStatic: true, render: { fillStyle: bColor } });
    var bucketRight = Bodies.rectangle(w + distanceOffset, h / 2, 300, h - (h / 5), { label: 'bucketRight', isSensor: true, isStatic: true, render: { fillStyle: bColor } });

    var activeWord = Bodies.polygon(
      w / 2,
      h / 2,
      randomShape(),
      shapeSize,
      {
        frictionAir: 0.01,
        restitution: 1,
        chamfer: { radius: 15 },
        inertia: Infinity,
        rotationSpeed: 0.0005,
        render: {
          fillStyle: shapeBgColor,
          text: { content: words[wordIndex].text, size: fontSize, color: shapeFontColor, maxWidth: 25 + shapeSize }
        },
        label: 'activeWord'
      }
    );




    if (numberOfBuckets == 1)
      World.add(engine.world, [leftWall, topWall, bottomWall])
    if (numberOfBuckets == 2)
      World.add(engine.world, [bucketLeft, topWall, bottomWall])
    if (numberOfBuckets == 3)
      World.add(engine.world, [bucketLeft, bucketBottom, topWall])
    if (numberOfBuckets >= 4)
      World.add(engine.world, [bucketLeft, bucketBottom, bucketTop])

    World.add(engine.world, [
      corner_top_left_x, corner_top_left_y,
      corner_top_right_x, corner_top_right_y,
      corner_bottom_left_x, corner_bottom_left_y,
      corner_bottom_right_x, corner_bottom_right_y,
      mouseConstraint, bucketRight, activeWord
    ])

    function updateRotation() {
      Body.setAngle(activeWord, activeWord.angle - activeWord.rotationSpeed);
      requestAnimationFrame(updateRotation);
    }
    window.requestAnimationFrame(updateRotation);

    Matter.Runner.run(engine);
    Render.run(render);

    Events.on(mouseConstraint, 'mousedown', function (event) {
      userClicking = true
    })

    Events.on(mouseConstraint, 'mouseup', function (event) {
      userClicking = false
    })

    Events.on(engine, 'collisionActive', function (event) {
      var pairs = event.pairs;
      for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i];
        if  ((pair.bodyA === bucketRight) ||
            (pair.bodyA === bucketLeft) ||
            (pair.bodyA === bucketBottom) ||
            (pair.bodyA === bucketTop)) {
              activeWord.render.fillStyle = theme.pageStyle3.hint1
              if (userClicking === false) {
                if (pair.bodyA === bucketRight) { nextWord(0) }
                if (pair.bodyA === bucketLeft) { nextWord(1) }
                if (pair.bodyA === bucketBottom) { nextWord(2) }
                if (pair.bodyA === bucketTop) { nextWord(3) }
              }
        }
      }
    })

    Events.on(engine, 'collisionEnd', function (event) {
      activeWord.render.fillStyle = shapeBgColor
    })

    Events.on(engine, 'collisionStart', function (event) {

    })

    const handleKeyDown = (event) => {
      if (event.key.startsWith("Arrow")) {
        event.preventDefault()
        event.stopPropagation()
        console.log('KEY:' + event.key)
        if (event.key === "ArrowLeft") {
          nextWord(1)
        } else if (event.key === "ArrowRight") {
          nextWord(0)
        } else if (event.key === "ArrowUp") {
          nextWord(3)
        } else if (event.key === "ArrowDown") {
          nextWord(2)
        }
      }
    }

    function nextWord(direction) {

      let bucket = qData.options[direction].text;

      // show the label
      let thisLabel = document.getElementById('label-key-'+direction);
      if (thisLabel) {
        thisLabel.classList.add('active');
        setTimeout(
          function () { thisLabel.classList.remove('active') },
          750
        );
      }

      // save response...
      let response = {
        [words[wordIndex].text]: bucket
      }
      setCollectResponses(current => [...current, response]);

      World.remove(engine.world, activeWord);

      let audio = new Audio(wand);
      audio.volume = 0.75;
      audio.play();

      if (wordIndex == words.length - 1) {
        // show the Next btn
        setAllComplete(true);
      } else {
        wordIndex++;
        activeWord = Bodies.polygon(
          w / 2,
          h / 2,
          randomShape(),
          shapeSize,
          {
            frictionAir: 0.01,
            restitution: 1,
            chamfer: { radius: 15 },
            inertia: Infinity,
            rotationSpeed: 0.0005,
            render: {
              fillStyle: shapeBgColor,
              text: { content: words[wordIndex].text, size: fontSize, color: shapeFontColor, maxWidth: 25 + shapeSize }
            },
            label: 'activeWord'
          }
        );

        setTimeout(function() {
          World.add(engine.world, activeWord);
          Body.setVelocity(activeWord, { x: 0, y: random(-1, 2) });
          function updateRotation() {
            Body.setAngle(activeWord, activeWord.angle - activeWord.rotationSpeed);
            requestAnimationFrame(updateRotation);
          }
          window.requestAnimationFrame(updateRotation);
        }, 750)
      }
    }

    setContraints(boxRef.current.getBoundingClientRect())
    setScene(render)
    window.addEventListener('resize', handleResize)
    window.addEventListener('keydown', handleKeyDown)

  }, [])

  useEffect(() => {
    return () => {
      window.removeEventListener('resize', handleResize)
      //window.removeEventListener('keydown', handleKeyDown)
    }
  }, [])

  useEffect(() => {
    if (constraints) {
      let { width,height } = constraints

      // Dynamically update canvas and bounds
      scene.bounds.max.x = width
      scene.bounds.max.y = height
      scene.options.width = width
      scene.options.height = height
      scene.canvas.width = width
      scene.canvas.height = height

      let w = width,
        h = height;

      scene.engine.world.bodies.map((body, index) => {
        switch(body.label) {
          case 'corner_top_left_x':
            Matter.Body.setPosition(body, { x: w/20, y: -280 }); break;
          case 'corner_top_left_y':
            Matter.Body.setPosition(body, { x: -280, y: h/20 }); break;
          case 'corner_top_right_x':
            Matter.Body.setPosition(body, { x: w - (w / 20), y: -280 }); break;
          case 'corner_top_right_y':
            Matter.Body.setPosition(body, { x: w + 280, y: h / 20 }); break;
          case 'corner_bottom_left_x':
            Matter.Body.setPosition(body, { x: w / 20, y: h + 280 }); break;
          case 'corner_bottom_left_y':
            Matter.Body.setPosition(body, { x: -280, y: h - (h / 20) }); break;
          case 'corner_bottom_right_x':
            Matter.Body.setPosition(body, { x: w - (w / 20), y: h + 280 }); break;
          case 'corner_bottom_right_y':
            Matter.Body.setPosition(body, { x: w + 280, y: h - (h / 20) }); break;
          case 'topWall':
            Matter.Body.setPosition(body, { x: w / 2, y: -280 }); break;
          case 'bottomWall':
            Matter.Body.setPosition(body, { x: w / 2, y: h + 280 }); break;
          case 'leftWall':
            Matter.Body.setPosition(body, { x: -280, y: h / 2 }); break;
          case 'bucketTop':
            Matter.Body.setPosition(body, { x: w / 2, y: -distanceOffset }); break;
          case 'bucketBottom':
            Matter.Body.setPosition(body, { x: w / 2, y: h + distanceOffset }); break;
          case 'bucketLeft':
            Matter.Body.setPosition(body, { x: -distanceOffset, y: h / 2 }); break;
          case 'bucketRight':
            Matter.Body.setPosition(body, { x: w + distanceOffset, y: h / 2 }); break;
          default:
        }
      })

    }
  }, [scene, constraints])

  const onSubmit = (data) => {

    const dataToSend = {
      "questionId": qData.id,
      "bucketValue": collectResponses
    }

    nextStep(dataToSend);
  }

  const labelHtml = qData.options.map((option, index) =>
    <div id={`label-key-${index}`} key={index} className={`absolute text-xs md:text-sm font-black bucket_label l-${index}`}>{option.text}</div>
  );

  return (
    <>
      <div className="grow">
        {labelHtml}
      </div>
      <div ref={boxRef} className="w-screen h-screen absolute top-0 left-0"></div>
      <NitroButton formIsValid={allComplete} label="Next" onClick={onSubmit} />
    </>
  );
}

export default BucketSorter;
